/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSelector } from "react-redux";
import { selectFieldByPosition } from "data/store/reducers/model";
import { useDynamicFieldPosition } from "../context/dynamic-field-context-hooks";

export function useCurrentDynamicField () {
    
    const position = useDynamicFieldPosition();
    const field = useSelector((state) => {
        return selectFieldByPosition(state, position);
    });

    return {
        field,
        position,
    };
}
